"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _useCss = _interopRequireDefault(require("../../hooks/useCss.hook"));
var _Tab = _interopRequireDefault(require("../Tab"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var defaultOptions = [];
var Tabs = function Tabs(props) {
  var value = props.value,
    onChange = props.onChange,
    _props$options = props.options,
    options = _props$options === void 0 ? defaultOptions : _props$options;
  var rootRef = (0, _react.useRef)(null);
  var dragStateRef = (0, _react.useRef)(false);
  var rootClass = (0, _useCss["default"])(function (theme) {
    return {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      overflow: 'auto',
      flexShrink: 0,
      backgroundColor: theme.palette.accent.primary.contrast.low
    };
  });

  // Drag scroll
  (0, _react.useEffect)(function () {
    var element = rootRef.current;
    var mouseDown = false;
    var startX = null;
    var scrollX = null;
    var listenScrollStart = function listenScrollStart(e) {
      if (!element) {
        return;
      }
      mouseDown = true;
      startX = e.clientX;
      scrollX = element.scrollLeft;
    };
    var listenScroll = function listenScroll(e) {
      if (mouseDown && typeof startX === 'number' && element) {
        var offsetX = e.clientX - startX;
        if (Math.abs(offsetX) < 5) {
          return;
        }
        dragStateRef.current = true;
        if (element.scrollWidth < element.offsetWidth) {
          return;
        }
        if (scrollX === null) {
          return;
        }
        var newScrollX = scrollX - offsetX;
        element.scrollLeft = newScrollX;
      }
    };
    var listenScrollEnd = function listenScrollEnd(e) {
      var isElement = !!element;
      var isTargetNode = e.target instanceof Node;
      var isInsideDom = isElement && isTargetNode;
      var isTargetInside = isInsideDom && element.contains(e.target);
      var isTheSameNode = isInsideDom && element === e.target;
      var preventClick = isTargetInside || isTheSameNode;
      if (!preventClick) {
        dragStateRef.current = false;
      }
      mouseDown = false;
      startX = null;
      scrollX = null;
    };
    if (element) {
      element.addEventListener('mousedown', listenScrollStart);
      window.addEventListener('mousemove', listenScroll);
      window.addEventListener('mouseup', listenScrollEnd);
    }
    return function () {
      if (element) {
        element.removeEventListener('mousedown', listenScrollStart);
      }
      window.removeEventListener('mousemove', listenScroll);
      window.removeEventListener('mouseup', listenScrollEnd);
      dragStateRef.current = false;
      mouseDown = false;
      startX = null;
      scrollX = null;
    };
  }, []);
  var handleChange = (0, _react.useCallback)(function (v) {
    return function () {
      if (onChange && !dragStateRef.current) {
        onChange(v);
      }
      dragStateRef.current = false;
    };
  }, [onChange]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: rootClass,
    ref: rootRef,
    children: options.map(function (opt) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tab["default"], {
        active: value === opt.value,
        onClick: handleChange(opt.value),
        children: opt.label
      }, opt.value);
    })
  });
};
var _default = Tabs;
exports["default"] = _default;